import { IHttpApi } from '@cian/http-api/shared';

import { GET_BUILDER_SUGGESTIONS_TIMEOUT } from '../../node/constants';
import { IBuilderSuggest } from '../types/builder';
import {
  fetchGetBuilderSuggests,
  IGetBuilderSuggestsRequest,
  IGetBuilderSuggestsResponse200,
  IGetBuilderSuggestsResponse400,
} from '../repositories/countryside-search/v1/get-builder-suggests';

export async function getBuilderSuggests(httpApi: IHttpApi, parameters: IGetBuilderSuggestsRequest) {
  const { response, statusCode } = await fetchGetBuilderSuggests<
    IGetBuilderSuggestsResponse200,
    IGetBuilderSuggestsResponse400
  >({
    httpApi,
    parameters,
    config: {
      ecnhancersConfig: {
        timeout: GET_BUILDER_SUGGESTIONS_TIMEOUT,
      },
    },
  });

  if (statusCode !== 200 || 'errors' in response) {
    throw response;
  }

  return response.suggests as IBuilderSuggest[];
}
